    
<template>
    <div class="dashBox">
        <div class="dashTitle">
            <span>业务调用量趋势图 </span>
            <a-select mode="default" v-model="chartPerTime" @change="handleChartPerTimeChange" style="width: 80px;float:right;margin-top:2px;" placeholder="请选择时间">
                <a-select-option v-for="(value,name) in perTimeValue" :key="name" :value="name">
                    {{name}}
                </a-select-option>
            </a-select>
        </div>
        <!-- <a-empty v-if="data.length == 0" description="暂无数据" style="margin-top:80px;" /> -->
         <a-spin :spinning="chartloading" >
            <div id="serviceViewChart" style="width: 100%;padding-top:10px;"></div>
         </a-spin>
    </div>
</template>

<script>
const perTimeValue = {
    '1秒':'1s',
    '1分钟':'1m',
    '5分钟':'5m',
    '10分钟':'10m',
    '1小时':'1h',
    '1天':'1d',
}
export default {
    data() {
        return {
           
            chartDate:[],
            chartValue:[],
            chartloading:false,
            perTimeValue,
            tempSearchKey:{},
            chartPerTime:''
        }
    },

    methods: {
        handleChartPerTimeChange(v){
            this.chartPerTime = v;
            this.getChartData(this.tempSearchKey,v);
        },
        /**
         * 根据所选服务和时间范围查询
         */
        getChartData(searchKey,chartPerTime){

            this.chartPerTime = chartPerTime;
            this.tempSearchKey = searchKey;
            let perN = this.perTimeValue[chartPerTime];

            let whereStr = " where 1=1 ";
            if(searchKey.selectedAppcode){
                whereStr += "and AppCode = '" + searchKey.selectedAppcode + "'";
            }
            if(searchKey.selectedInvokeappcode){
                whereStr += "and invokeappcode = '" + searchKey.selectedInvokeappcode + "'";
            }
            if(searchKey.servicekey){
                whereStr += "and url = '" + searchKey.servicekey + "'";
            }
            if(searchKey.clientip){
                whereStr += "and clientip = '" + searchKey.clientip + "'";
            }
            let queryStr = "* | select count(1) as pv ,time_series(starttime, '"+perN+"', '%Y-%m-%d %H:%i:%s' ,'0') as occurtime " + 
            " from log " + whereStr + " group by occurtime order by occurtime";
            let that = this;
            let starttime = (new Date(searchKey.searchTimeRange.split('~')[0]).getTime())/1000;
            let endtime = (new Date(searchKey.searchTimeRange.split('~')[1]).getTime())/1000;

            that.chartloading = true;
            that.tLoading = true;
            let params = {
                projectname:that.G.getServiceMonitorName(),
                logstorename:'service-monitor',
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:100,
                offset:0,
                paged:false,
                reverse:false,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let resultDate = res.data.data.list
                    that.chartDate = [];
                    that.chartValue = [];
                    that.sumChartValue = 0;
                    for (let index = 0; index < resultDate.length; index++) {
                        const element = resultDate[index];
                        let tempTime = "";
                        if(this.chartPerTime == '1秒'){
                            tempTime = (new Date(element.occurtime)).Format('MM-dd hh:mm:ss');
                        }
                        else{
                            tempTime = (new Date(element.occurtime)).Format('MM-dd hh:mm');
                        }
                        that.chartDate.push(tempTime);
                        that.chartValue.push(element.pv)
                    }
                    that.analystData();
                }
                that.chartloading = false;
            }).catch(() => {
                that.chartloading = false;
            });
        },

        //按日期统计数据
        analystData(){
            let that = this;
            if(that.chartSys){
                that.chartSys.clear();
            }
            document.getElementById("serviceViewChart").style.height = "360px";
            that.chartSys = that.$echarts.init(document.getElementById("serviceViewChart"));
            
            let option = that.getDatailOption();
            // 窗口大小自适应方案
            that.chartSys.setOption(option);
            that.chartSys.off('click');
            that.chartSys.on('click', function (e) {
                let targetTime = e.name.replace('\n',' ');
                let targetYear = new Date(that.tempSearchKey.searchTimeRange.split('~')[0]).Format('yyyy');

                let pointMinite = targetYear + '-' + targetTime;
                let pointEnd = new Date(pointMinite).getTime() + 60000;
                if(that.chartPerTime != '1秒'){
                    let searchTimeRange = pointMinite + '~' + new Date(pointEnd).Format('yyyy-MM-dd hh:mm')
                    let monitorDetail = localStorage.getItem("monitorserviceDetailSearch");
                    if(monitorDetail){
                        monitorDetail = JSON.parse(monitorDetail);
                        monitorDetail.searchTimeRange = searchTimeRange;
                        monitorDetail.timeType = 7;
                        localStorage.setItem("monitorserviceDetailSearch",JSON.stringify(monitorDetail));
                        that.$router.push({
                            path: "/monitorservice/servicesum",
                            query:{
                                searchTimeRange:searchTimeRange,
                                dateTypeTitle:7
                            }
                        });
                    }
                    
                }
            });
            
        },
        getDatailOption(){
            let that = this;
            let option = {
                xAxis: {
                    type: 'category',
                    data: that.chartDate.map(function (str) {
                        return str.replace(' ', '\n');
                    })
                },
                color:that.G.getChartColors(),
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: that.chartValue,
                    type: 'line',
                    smooth: true
                }]
            };
            return option;
        },
        chartResize(){
            let eleArr = [this.chartSys];
            for(let i = 0; i<eleArr.length; i++){
                //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
                setTimeout(function(){
                    if(eleArr[i]){
                        eleArr[i].resize();
                    }
                }, 200);
            }
        },
    },
    mounted() {
        window.addEventListener("resize", this.chartResize);
    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    },

}
</script>

<style scoped>

    .dashBox{
        min-height: 395px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;
    }
    .dashTitle{
        width: 100%;
        height: 40px;
        color: #00c1de;
        line-height:38px;
        padding:0 10px;
        border-bottom: 1px solid lightgray;
        cursor: default;
    }
</style>
